import { render, staticRenderFns } from "./drop-down.vue?vue&type=template&id=28524f3c"
import script from "./drop-down.vue?vue&type=script&lang=js"
export * from "./drop-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports